import $ from 'jquery';
import Swiper from 'swiper';

export let windowsWidth = $(window).width();

export const setupWindowResizeListener = (): void => {
  $(window).on('resize', () => {
    windowsWidth = $(window).width();
  });
};

export const removeWindowResizeListener = (): void => {
  $(window).off('resize');
};

export const setActivelink = (): void => {
  const activePage = window.location.href;
  
  // Set active class on header navbar links.
  $('#header-navbar .navbar-nav .nav-item .nav-link').each(function () {
    const linkPage = (this as HTMLAnchorElement).href;
    if (activePage === linkPage) {
      $(this).addClass('active').attr('aria-current', 'page');
    }
  });

  // Set active class on sidebar links.
  $('.adminuiux-sidebar .adminuiux-sidebar-inner .nav .nav-item .nav-link').each(function () {
    const linkPage =  (this as HTMLAnchorElement).href;
    if (activePage === linkPage) {
      $(this).addClass('active');
      $(this).closest('.dropdown').find('.dropdown-menu').addClass('show');
      $(this).closest('.dropdown').find('.dropdown-toggle').addClass('show');
    }
  });

  // Set active class on mobile footer links if the element exists.
  if ($('.adminuiux-mobile-footer').length > 0) {
    $('.adminuiux-mobile-footer .nav .nav-item .nav-link').each(function () {
      const linkPage =  (this as HTMLAnchorElement).href;
      if (activePage === linkPage) {
        $(this).addClass('active').attr('aria-current', 'page');
      }
    });
  }
};

export const fixedHeaderSpace = (): void => {
  if ($('.adminuiux-header .navbar').hasClass('fixed-top')) {
    const headerHeight = $('.adminuiux-header .navbar').outerHeight();
    $('.adminuiux-sidebar').css('padding-top', headerHeight);
    $('.adminuiux-content').css('padding-top', headerHeight);
  }
};

export const coverimg = (): void => {
  $('.coverimg').each(function () {
    const imgSrc = $(this).find('img').attr('src');
    if (imgSrc) {
      $(this).css('background-image', `url(${imgSrc})`);
      $(this).find('img').hide();
    }
  });
};

export const closeSearch = (): void => {
  $('.adminuiux-search-full').removeClass('active');
};

export const openSearch = (): void => {
  $('.adminuiux-search-full').addClass('active');
};

export const initSidebar = (): void => {
  // Calculate the window width and select the body element.
  const windowswidth = $(window).width();
  const body = $('body');

  // Toggle sidebar classes based on the window width.
  if (windowswidth >= 992) {
    body.toggleClass('sidebar-close');
  } else {
    body.toggleClass('sidebar-open');
  }
};

export const contentClick = (): void => {
  if ($('.adminuiux-search-full').hasClass('active')) {
    $('.adminuiux-search-full').removeClass('active');
  }
  if ($('body').hasClass('sidebar-open')) {
    $('body').removeClass('sidebar-open');
  }
};

export const swipernav = (): void => {
  if ($('.swipernav').length > 0) {
    const _swiper = new Swiper('.swipernav', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
    });
  }
};

export function capitaliseFirstLetter(text: string | undefined): string {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
}